<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector>
    </vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items [locationId]="'event-email-template-list'"></vdr-action-bar-items>
      <a class="btn btn-primary" [routerLink]="['./', 'create']">
        <clr-icon shape="plus"></clr-icon>
        {{ "common.create" | translate }}
      </a>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-data-table-2
  id="event-email-template-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="event-email-template-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />
  <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-alert="item">
      {{ alert.id}}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="subject"
    [heading]="'common.name' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-template="item">
      <a class="button-ghost" [routerLink]="['/extensions/event-email-templates', template.id]">
        <span>
          {{ template.name }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="subject"
    [heading]="'common.subject' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-alert="item">
      {{ alert.subject }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="content"
    [heading]="'common.content' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-alert="item">
      {{ alert.content }}
    </ng-template>
  </vdr-dt2-column>

</vdr-data-table-2>
